/**
 * Корневой компонент: провайдеры (QueryClient, Toast, Confirm, Auth) и
 * AppContent — маршрутизация по auth-состоянию.
 *
 * AppContent:
 *  - isLoading → «Загрузка…»;
 *  - !user → LoginScreen (режим login);
 *  - forceChangePassword === true → LoginScreen с forcePasswordChange
 *    (форма сразу в режиме «Смена пароля»);
 *  - иначе → MainLayout.
 */
import { QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "./context/ToastProvider";
import { useToast } from "./context/ToastContext";
import { ConfirmProvider } from "./context/ConfirmProvider";
import { AuthProvider } from "./auth/AuthProvider.jsx";
import { useAuth } from "./hooks/useAuth";
import { useInputModality } from "./hooks/useInputModality";
import { queryClient } from "./api/queryClient";
import LoginScreen from "./components/LoginScreen";
import MainLayout from "./components/MainLayout";

function AppContent() {
  const { user, isLoading, forceChangePassword } = useAuth();
  const { showToast } = useToast();

  if (isLoading) {
    return <div className="empty-note p-4">Загрузка…</div>;
  }

  if (!user) {
    return <LoginScreen toast={showToast} />;
  }

  if (forceChangePassword) {
    return <LoginScreen toast={showToast} forcePasswordChange />;
  }

  return <MainLayout user={user} />;
}

export default function App() {
  useInputModality();
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ConfirmProvider>
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        </ConfirmProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
